<svg
  class="w-[1em] h-[1em]"
  viewBox="0 0 24 24"
  fill="currentColor"
  focusable="false"
  [attr.role]="label ? 'img' : null"
  [attr.aria-label]="label || null"
  [attr.aria-hidden]="label ? null : true"
  data-testid="aiIcon"
>
  <title *ngIf="label">{{ label }}</title>
  <path d="M9 1 Q10.2 7.8 17 9 Q10.2 10.2 9 17 Q7.8 10.2 1 9 Q7.8 7.8 9 1 Z" />
  <path
    d="M18.5 13.5 Q19.2 17.8 23.5 18.5 Q19.2 19.2 18.5 23.5 Q17.8 19.2 13.5 18.5 Q17.8 17.8 18.5 13.5 Z"
  />
</svg>
